<template>
	<div id="portability-page">

		<div class="cv-rounded">

            <div class="w-100 d-md-none">
                <!-- <img src="https://placehold.co/600x350/00B04E/ffffff?text=Portabilidad" alt="Portabilidad" class="img-fluid w-100"> -->
				<img src="@/assets/banners-clave-verde/optmized/BannerPortabilidad600x350px.jpg" alt="Portabilidad" class="img-fluid w-100" />
            </div>
    
            <div class="w-100 d-none d-md-block d-lg-none">
                <img src="@/assets/banners-clave-verde/optmized/BannerPortabilidad700x250px.jpg" alt="Portabilidad" class="img-fluid w-100" />
            </div>
    
            <div class="w-100 d-none d-lg-block">
                <img src="@/assets/banners-clave-verde/optmized/BannerPortabilidad1920x300.jpg" alt="Portabilidad" class="img-fluid w-100" />
            </div>

        </div>

		<b-tabs id="portability-tabs" content-class="mt-0" align="center" pills card :fill="!isFullWidth">
			<b-tab title="Portabilidad"  @click="tryRelocation('portabilityPageRoot')" :active="$route.name === 'portabilityPageRoot'"></b-tab>
			<b-tab title="¿Qué es?"  @click="tryRelocation('portabilityPageInfo')" :active="$route.name === 'portabilityPageInfo'"></b-tab>
			<b-tab title="Pasos para la Portabilidad" @click="tryRelocation('portabilityPageSteps')" :active="$route.name === 'portabilityPageSteps'"></b-tab>
		</b-tabs>

		<router-view class="limit-width mb-5" :key="$route.name"></router-view>

	</div>
</template>

<script>
export default {
	name: "portabilityPage",
	data:() => ({
		isFullWidth: false
	}),
	methods: {
		reviewWindowSize() {
			this.isFullWidth = window.innerWidth >= 768;
		},
		tryRelocation(locationName) {
			try {
				window.scrollTo(0, 0);
				if(this.$route.name === locationName) return;
				this.$router.push({ name: locationName }).catch(err => {
					if (err.name !== 'NavigationDuplicated') {
						throw err;
					}
				});
			} catch (e) {
				// do nothing
				console.error(e);
			}
		}
	},
	mounted() {
		this.reviewWindowSize();
		window.addEventListener('resize', this.reviewWindowSize);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.reviewWindowSize);
	}
}
</script>

<style lang="scss">
@import '@/scss/app.scss';
#portability-page {
	#portability-tabs {
		ul {
			@media (max-width: 400px) {
				flex-direction: column;
			}
		}
	}
}
</style>